export interface CancelFlowStep {
  type: CancelFlowStepType

  // Extra properties for extend-trial
  trial_end_current: string | null

  // Extra properties for survey
  survey_analytic_event: string | null
  survey_answers: SurveyAnswer[] | null

  // Extra properties for special-offer
  special_offer_header: string | null
  special_offer_body: string | null
  special_offer_card: SpecialOfferCard | null
}

export enum CancelFlowStepType {
  EXTEND_TRIAL = "extend-trial", // Extending the trial (this will only show up if in trial AND the user has never extended their trial before)
  PAUSE_SUBSCRIPTION = "pause-subscription", // Pauses subscription (we will only allow one pause every 3 months)
  SURVEY = "survey", // The survey. This one won't link to any action (just firing an analytic event)
  SPECIAL_OFFER = "special-offer", // Special offer. Backend controls the UI so that you don't need to know about prices/what the actual offer is
  CANCEL = "cancel", // actually canceling subscription
}

export interface SurveyAnswer {
  answer: string // the actual text to display
  freeform_title: string // the associated freeform textfield header
  analytic_param: string // the param for the survey
}

export interface SpecialOfferCard {
  header: string // in example above is the `Try our special Joon offer`
  body: string // in example above is the `$69.99 / year`
  body_subtext: string | null // in the example above is the `(20% savings)`
}

export interface CancelActionContent {
  title: string
  body: string
}

export enum CancelFlowModalType {
  JOONITY = "joonity",
  COACHING = "coaching",
}
